import Participant from "./Participant";

export default Participant;